import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios"
import { ElMessage, ElMessageBox } from "element-plus"
import { Session, Local } from "/@/utils/storage"
// import ARMSMonitoring, { type RumExceptionEvent } from '@/utils/arms';
// 配置新建一个 axios 实例
const service: AxiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    timeout: 50000,
    headers: { "Content-Type": "application/json" },
})

// 添加请求拦截器
service.interceptors.request.use(
    (config:InternalAxiosRequestConfig) => {
        // 在发送请求之前做些什么 token
        if (!JSON.stringify(config.url).includes("loginV2")) {
            config.headers!["Authorization"] = `Bearer ${Local.get("token")}`
            config.headers!["tenant-id"] = Local.get("tenantId")
        }
        return config
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error)
    },
)

// 添加响应拦截器
service.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        const res = response.data
        if (res.code && res.code !== 0) {
            // arms上报后端接口错误
            // if (res.code !== 200) {
            //     setTimeout(() => {
            //         try {
            //             ARMSMonitoring.reportError({
            //                 name: '后端接口错误',
            //                 message: res.msg,
            //                 stack: JSON.stringify({
            //                     code: res.code,
            //                     msg: res.msg,
            //                     url: response.config?.url,
            //                     timestamp: Date.now(),
            //                 }),
            //             } as RumExceptionEvent);
            //         } catch (error) {
            //             console.warn('ARMS 上报失败:', error);
            //         }
            //     }, 0);
            // }
            
            // `token` 过期或者账号已在别处登录
            if (res.code === 401) {
                //|| res.code === 4001
                Local.clear() // 清除浏览器全部临时缓存
                Session.clear()
                window.location.href = "/" // 去登录页
                ElMessageBox.alert("你已被登出，请重新登录", "提示", {})
                    .then(() => {})
                    .catch(() => {})
            }
            return Promise.resolve(res) //service.interceptors.response
        } else if (res.code === 0) {
            return response.data
        }
    },
    error => {
        // 对响应错误做点什么
        if (error.message.indexOf("timeout") != -1) {
            ElMessage.error("网络超时")
        } else if (error.message == "Network Error") {
            ElMessage.error("网络连接错误")
        } else {
            if (error.response.data) ElMessage.error(error.response.statusText)
            else ElMessage.error("接口路径找不到")
        }
        return Promise.reject(error)
    },
)

// 导出 axios 实例
export default service

export interface IAxiosResponse<T = any> {
    code: number
    msg: string
    data: T
}
